import type { TransactionDetailTab } from 'src/component-layout/TransactionDetailTabs/TransactionDetailTabs'

export interface TransactionDetailTabState {
  transactionId: string | undefined
  activeTab: TransactionDetailTab
}

export const getTransactionDetailTabState = (
  current: TransactionDetailTabState,
  transactionId: string | undefined,
): TransactionDetailTabState =>
  current.transactionId === transactionId
    ? current
    : {
        transactionId,
        activeTab: 'overview',
      }
